import React, { useEffect, useState } from 'react'
import { getData, updateData } from '../../resources'
import { Card, Typography } from 'antd'
import { CalendarOutlined, ClockCircleOutlined, DollarOutlined } from '@ant-design/icons'
import HistorialCitas from './historialCitas';
const { Paragraph } = Typography;


export default function LastCita(props) {

    const [cita, setCita] = useState(null)
    const [citasData, setCitasData] = useState({})
    const [lastBalance, setLastBalance] = useState([])
    // const [editableStr, setEditableStr] = useState('Sin costo registrado');
    const [loading, setLoading] = useState(true)

    useEffect(() => { getCitasData() }, [])

    const updateLastBalance = (newMonto) => {

        let newLastBalance = lastBalance;
        newLastBalance.monto = newMonto;
        updateData(`balances/update/${lastBalance._id}`, newLastBalance).then(getCitasData)
    }

    const getLastCta = (eventos) => {
        var fechaActual = new Date();

        // Filtrar los eventos que tienen una fecha menor o igual a la fecha actual
        var eventosPasados = eventos.filter(function (evento) {
            var fechaEvento = new Date(evento.fecha_hora);
            return fechaEvento <= fechaActual;
        });

        // Ordenar los eventos pasados por fecha de forma descendente
        eventosPasados.sort(function (a, b) {
            var fechaA = new Date(a.fecha_hora);
            var fechaB = new Date(b.fecha_hora);
            return fechaB - fechaA;
        });

        // Obtener el evento más reciente
        return eventosPasados[0]
    }

    const getCitasData = () => {
        getData(`citas/${props.paciente}`).then((rs) => {
            const eventos = Array.isArray(rs) ? rs : []
            const ultimaCita = getLastCta(eventos);
            // console.log('lsat cita', ultimaCita)
            setCita(ultimaCita)
            setCitasData(eventos.reverse())
            return ultimaCita
        }).then((last) => {
            return last ? getData('balances/cita/' + last._id) : []
        }).then((bl) => {
            // console.log('balance', bl)
            setLastBalance(Array.isArray(bl) ? bl[0] : undefined)
        }).finally(() => setLoading(false))
    }

    const LastBalance = () => {
        return <div>
            {
                lastBalance && lastBalance.monto ?
                    (
                        <div >

                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', columnGap: '10px' }}>
                                <DollarOutlined style={{}} />
                                Costo:
                                <Paragraph
                                    style={{ marginTop: 14 }}
                                    editable={{
                                        onChange: updateLastBalance,
                                    }}
                                >
                                    {lastBalance.monto}
                                </Paragraph>


                            </div>

                            {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', columnGap: '10px' }}>
                             <CalendarOutlined /> {new Date(lastBalance.createdAt).toLocaleDateString()}
                         </div> */}
                        </div>
                    ) : (
                        <p className='desc' style={{marginTop: 6}}>Sin Último Balance</p>
                    )
            }

        </div>
    }


    if (loading) return <p>Cargando...</p>
    return (
        <div style={{ marginTop: 8 }}>
            <Card>
                {cita?.fecha_hora ? (
                    <div>
                        <h6 style={{ fontWeight: 600, marginBottom: 10 }}>Cita más reciente</h6>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                                <CalendarOutlined style={{ color: '#1890ff' }} />
                                <span>Fecha: <strong>{new Date(cita.fecha_hora).toLocaleDateString()}</strong></span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                                <ClockCircleOutlined style={{ color: '#1890ff' }} />
                                <span>Hora: <strong>{cita.fecha_hora.substring(11, 16)}</strong></span>
                            </div>
                        </div>
                        <HistorialCitas historial={citasData} />
                        <LastBalance />
                    </div>
                ) : (
                    <h6 style={{ color: '#bbb', fontWeight: 400 }}>Sin cita reciente registrada</h6>
                )}
            </Card>
        </div>
    )
}